export enum CFAttrType {
	Validation = 'Validation',
	ReactTable = 'ReactTable',
	DataFilter = 'DataFilter',
	persNr = 'persNr',
	date = 'date',
}

export enum CFAttrKey {
	align = 'align',
	alwaysSet = 'alwaysSet',
	attributionControl = 'attributionControl',
	colorTextView = 'colorTextView',
	ClipboardCopy = 'copyToClipboard',
	ClipboardCopySingleValue = 'copySingleValueToClipboard',
	ClipboardCopyOnOpen = 'copyToClipboardOnOpen',
	ClipboardCopySingleValueOnOpen = 'copySingleValueToClipboardOnOpen',
	ClipboardCopyOverride = 'copyToClipboardOverride',
	ClipboardPaste = 'pasteFromClipboard', // only init
	ClipboardPasteOnChangeOnlyInit = 'pasteFromClipboardOnChangeOnlyInit', // only init
	ClipboardPasteOnChange = 'pasteFromClipboardOnChange', // always overwrite
	ClipboardClear = 'clearClipboard',
	ClipboardClearOnChange = 'clearClipboardOnChange',
	disabled = 'disabled',
	disableManualSort = 'disableManualSort',
	displayFormat = 'displayFormat',
	durationFormat = 'durationFormat',
	dqLabelInTextView = 'dqLabelInTextView',
	dqLabelInTextViewDqKey = 'dqLabelInTextViewDqKey',
	dqLabelInTextViewDqParam = 'dqLabelInTextViewDqParam',
	filterable = 'filterable',
	filterMethod = 'filterMethod',
	focusOnAdd = 'focusOnAdd',
	ForceRequired = 'ForceRequired',
	ForceRequiredAny = 'ForceRequiredAny',
	ForceRequiredXOR = 'ForceRequiredXOR',
	fullscreenControl = 'fullscreenControl',
	googleLinkControl = 'googleLinkControl',
	googleLinkUrl = 'googleLinkUrl',
	hideLabel = 'hideLabel',
	initAttr = 'initAttr',
	initFromStammKost = 'initFromStammKost',
	initValue = 'initValue',
	initValueFromDq = 'initValueFromDq',
	initValueFromDqParam = 'initValueFromDqParam',
	initValueFromStTag = 'initValueFromStTag',
	initValueFromTask = 'initValueFromTask',
	initValueFromTaskAttr = 'initValueFromTaskAttr',
	inlineLabel = 'inlineLabel',
	labelInTextView = 'labelInTextView',
	maintenanceColumnWidth = 'maintenanceColumnWidth',
	maintenanceColumnWidthMax = 'maintenanceColumnWidthMax',
	memoSelected = 'memoSelected',
	memoAutoAdd = 'memoAutoAdd',
	menuWidth = 'menuWidth',
	maxAmount = 'maxAmount',
	maxWidthTextView = 'maxWidthTextView',
	minWidthTextView = 'minWidthTextView',
	moveCF = 'moveCF',
	negate = 'negate',
	openLinkTarget = 'openLinkTarget',
	optional = 'optional',
	copyPasteEnabled = 'copyPasteEnabled',
	preserveDateRangeForAttribute = 'preserveDateRangeForAttribute',
	preserveDateRangeForCFDef = 'preserveDateRangeForCFDef',
	preserveEndTimeToStartTimeDstField = 'preserveEndTimeToStartTimeDstField',
	remoteSetterDq = 'remoteSetterDq',
	remoteSetterDqParam = 'remoteSetterDqParam',
	remoteSetterDstAttr = 'remoteSetterDstAttr',
	remoteSetterDstCFDefId = 'remoteSetterDstCFDefId',
	roundTime = 'roundTime',
	roundTimeEndReferencedStartDstField = 'roundTimeEndReferencedStartDstField',
	roundDuration = 'roundDuration',
	roundException = 'roundException',
	searchDqKey = 'searchDqKey',
	searchInput = 'searchInput',
	selectFirstVisible = 'selectFirstVisible',
	separator = 'separator',
	Sequential = 'Sequential',
	showAccuracy = 'showAccuracy',
	showOnlyVisible = 'showOnlyVisible',
	sisName = 'sisName',
	switchMaptypeControl = 'switchMaptypeControl',
	TimeFromAttr = 'TimeFromAttr',
	textClippedTextView = 'textClippedTextView',
	transformCFData = 'transformCFData',
	visibleInTextView = 'visibleInTextView',
	positionInTextView = 'positionInTextView',
	zoom = 'zoom',
	precision = 'precision',
	min = 'min',
	max = 'max',
	step = 'step',
}